(function () {
    class ListUsersComponent {
        constructor(
            $scope,
            $state,
            $uibModal,
            NgTableParams,
            NgTableEventsChannel,
            UsersService,
            PermissionService,
            LocalisationService
        ) {
            $scope.addUser = this.addUser.bind(this);
            this.scope = $scope;
            this.state = $state;
            this.modal = $uibModal;
            this.usersService = UsersService;
            this.permissionService = PermissionService;
            this.ngTableParams = NgTableParams;
            this.userContext = this.permissionService.userContext;
            this.localisationService = LocalisationService;
            NgTableEventsChannel.onPagesChanged(this.scrollToTop, $scope);
            this.initialise();
        }

        initialise() {
            this.checkUserAccessToUserManagement();
            this.contextName = this.userContext.getCurrentContextName();

            this.usersTableParams = new this.ngTableParams(
                {
                    filterDelay: 300,
                    filter: {
                        filterText: ''
                    }
                }, {
                    getData: async (params) => {
                        const { filterText } = params.filter();
                        const { page, count } = params.url();
                        const start = (page * count) - count;
                        const result = await this.usersService.getAllUsersForContext(
                            count,
                            start,
                            this.userContext,
                            filterText);
                        const { data } = result;
                        Dashboard.helpers.tableHelper.useCount(
                            params,
                            data.TotalCount);
                        return data.Users;
                    }
                });
            this.scope.filterText = "";
            this.scope.$watch('filterText', (newValue, oldValue) => {
                const
                  old = (oldValue || "").trim().toLowerCase(),
                  updated = (newValue || "").trim().toLowerCase()
                if (old === updated) {
                    return;
                }
                this.updateListForFilterText(newValue || "")
            });
        };

        scrollToTop() {
            document.querySelector("body")
                .scrollIntoView({
                    block: 'start',
                    behavior: 'smooth'
                });
        }

        updateListForFilterText(filterText) {
            this.usersTableParams.filter({ filterText })
            this.usersTableParams.reload();
        }

        formatDate(date) {
            return this.localisationService.formatDateShort(date);
        }

        getDistinctRoleIds(roles) {
            const distinctRoleIdsSet = new Set(roles.map(role => role.RoleId))
            return [ ...distinctRoleIdsSet ];
        }

        formatRoles(roles) {
            if (!roles) {
                return "";
            }
            if (roles.length === 0) {
                return "";
            }
            const distinctRoleIds = this.getDistinctRoleIds(roles);
            let rolesStringArray = distinctRoleIds.map(roleId => roles.find(role => role.RoleId === roleId).Name);
            return rolesStringArray.join(", ");
        }

        checkUserAccessToUserManagement() {
            const { Permissions } = Dashboard.Models.Lookups;
            if (!this.permissionService.doesUserHavePermissionForContext(Permissions.ViewUsers)) {
                this.permissionService.navigateToAccessDenied();
            }

            this.hasPermissionToManageUsers =
                this.permissionService.doesUserHavePermissionForContext(
                    Permissions.ManageUsers
                ) || this.permissionService.doesUserHavePermissionForContext(
                    Permissions.ManageNonAdminUsers
                );
        };

        addUser() {
            this.state.go(".adduser", {
                brandId: this.userContext.BrandId,
                storeId: this.userContext.StoreId,
                callCenterId: this.userContext.CallCenterId
            });
        };

        manageUser(user) {
            this.state.go(".edituser", {
                id: user.Id,
                brandId: this.userContext.BrandId,
                storeId: this.userContext.StoreId,
                callCenterId: this.userContext.CallCenterId
            });
        }

        async removeUserByRoles(userId, roles) {
            await this.usersService.deleteUserRoles(userId, roles)
            this.usersTableParams.reload();
        }

        openRemoveUserModal(user) {
            const contextName = this.permissionService.userContext.getCurrentContextName();
            const modalTemplateUrl = "components/users/listusers/removeusermodal/removeusermodal.6d9d1c54.html";
            this.modal.open({
                animation: true,
                templateUrl: modalTemplateUrl,
                controller: "RemoveUserModalController",
                size: "lg",
                backdrop: "static",
                resolve: {
                    userId: () => user.Id,
                    roles: () => user.Roles,
                    displayName: () => `${ user.FirstName } ${ user.LastName }`,
                    contextName: () => contextName,
                    getDistinctRoleIds: () => this.getDistinctRoleIds.bind(this),
                    removeUserByRoles: () => this.removeUserByRoles.bind(this)
                }
            });
        }

        formatLocked(isLocked) {
            return isLocked
                ? "Yes"
                : "No";
        }
    }

    angular
        .module("dashboard")
        .component("listUsers",
            {
                templateUrl: "components/users/listusers/listusers.51182bfb.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$state",
                    "$uibModal",
                    "NgTableParams",
                    "ngTableEventsChannel",
                    "UsersService",
                    "PermissionService",
                    "LocalisationService",
                    ListUsersComponent
                ]
            });
})();
